module.exports = __webpack_public_path__ + "img/logo2.8699d9a4.png";